<ng-content select="cigna-omni-comm-channel-header"></ng-content>
<ng-content select="cigna-omni-comm-channel-subheader"></ng-content>
<ng-content select="cigna-omni-comm-channel-content"></ng-content>
<ng-content select="cigna-omni-comm-channel-button"></ng-content>
